import { Trigger as RadixTrigger, type DialogTriggerProps as RadixTriggerProps } from "@radix-ui/react-dialog";
import { forwardRef } from "react";

type Props = RadixTriggerProps;

const Trigger = forwardRef<HTMLButtonElement, Props>((props, ref) => <RadixTrigger {...props} ref={ref} />);

Trigger.displayName = "Dialog.Trigger";

export { Trigger as DialogTrigger };
export type { Props as DialogTriggerProps };
